import React, { FunctionComponent, KeyboardEvent } from 'react';
import { TextBox } from '@ds/ui';
import { inkSpacingTokens } from '@ds/tokens';
import styled from '@emotion/styled';

const FormUnit = styled.div`
    margin-bottom: ${inkSpacingTokens.spacingXS};
    max-width: 311px;
    margin-top: ${inkSpacingTokens.spacingS};
`;

type CodeTextInputProps = {
    onChange: (digits: string) => void;
    onKeyDown?: (key: string) => void;
    label: string;
    labelId?: string;
    numberOfDigits: number;
    dataQa: string;
    dataFocus: string;
    autocomplete: string;
    error?: string;
};

const DigitsInput: FunctionComponent<CodeTextInputProps> = ({ onChange, onKeyDown, label, labelId, numberOfDigits, dataQa, dataFocus, autocomplete, error }) => {
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    const handleKeyDown = (e: KeyboardEvent<any>) => {
        if (typeof onKeyDown === 'function') {
            onKeyDown(e.key);
        }
    };

    return (
        <FormUnit>
            <TextBox
                data-qa={dataQa}
                data-focus={dataFocus}
                label={label}
                labelId={labelId}
                error={error ?? ''}
                maxLength={numberOfDigits}
                inputMode={'numeric'}
                pattern={`[0-9]{${numberOfDigits}}`}
                onChange={handleOnChange}
                onKeyDown={handleKeyDown}
                required
                autoComplete={autocomplete}
            />
        </FormUnit>
    );
};

export default DigitsInput;
